import React from "react";
import { NavLink } from "react-router-dom";
import { LayoutGrid, CalendarDays, User, Home, Compass } from "lucide-react";
import { colors } from "@/lib/theme";
import { NotificationsBell } from "@/components/peeps/NotificationsBell";

const tabs = [
  { to: "/", label: "Activity", icon: Home, testID: "tab-activity", end: true },
  { to: "/groups", label: "Groups", icon: LayoutGrid, testID: "tab-groups" },
  { to: "/discover", label: "Discover", icon: Compass, testID: "tab-discover" },
  { to: "/agenda", label: "My Plans", icon: CalendarDays, testID: "tab-agenda" },
];

const pillStyle = { background: "rgba(32,33,44,0.85)", border: `1px solid ${colors.border}`, boxShadow: "0 8px 30px rgba(0,0,0,0.4)" };

export function TabLayout({ children }) {
  return (
    <div className="min-h-screen" style={{ background: colors.surface }}>
      <NotificationsBell />
      <div className="max-w-2xl mx-auto pb-28">{children}</div>

      <nav className="fixed bottom-0 left-0 right-0 z-40 flex justify-center pointer-events-none">
        <div className="pointer-events-auto flex items-center gap-2 mb-4">
          <div className="flex items-center gap-1 px-2 py-2 rounded-2xl backdrop-blur-xl" style={pillStyle}>
            {tabs.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.end}
                data-testid={t.testID}
                className="flex flex-col items-center justify-center gap-0.5 rounded-xl px-3 py-1.5 transition-colors"
              >
                {({ isActive }) => (
                  <>
                    <t.icon size={20} color={isActive ? colors.brandSecondary : colors.muted} fill="none" />
                    <span className="font-display font-medium text-[10.5px]" style={{ color: isActive ? colors.brandSecondary : colors.muted }}>{t.label}</span>
                  </>
                )}
              </NavLink>
            ))}
          </div>

          {/* Profile pulled out as its own button — it's account/settings, not a content tab. */}
          <NavLink
            to="/profile"
            end
            data-testid="tab-profile"
            className="flex flex-col items-center justify-center gap-0.5 rounded-2xl px-3.5 py-2.5 backdrop-blur-xl transition-colors"
            style={pillStyle}
          >
            {({ isActive }) => (
              <>
                <User size={20} color={isActive ? colors.brandSecondary : colors.onSurface} fill="none" />
                <span className="font-display font-semibold text-[10.5px]" style={{ color: isActive ? colors.brandSecondary : colors.onSurface }}>Profile</span>
              </>
            )}
          </NavLink>
        </div>
      </nav>
    </div>
  );
}

